import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import UserMenu from "./UserMenu";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import LimitUser from "./LimitUser";
import BurgerMenu from "./BurgerMenu";
import { listNav } from "../../utils/configData";

const Headers = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.user);
  const location = useLocation();

  const checkActive = (location, url) => {
    if (!location || !location.pathname) {
      return false;
    }

    // Перевірка для /transactions-list
    if (location.pathname === "/transactions-list" && url === "/transactions-list") {
      return true;
    }

    // Перевірка для /chat/
    if (location.pathname.startsWith("/chat/") && url === "/transactions-list") {
      return true;
    }

    return false;
  };

  const navLinks = (
    <nav className="only-desktop">
      {listNav.map((item, index) => (
        !item.isExternal ? (
          userInfo.type === 1 && item.url === "/" ? null : (
          <NavLink
            key={index}
            to={item.url}
            className={({ isActive }) => (isActive || checkActive(location, item.url) ? "active" : "")}
          >
            {t(item.name)}
          </NavLink>)

        ) : (
          <a key={index} href={item.url} rel="noreferrer" target="_blank">{item.name}</a>
        )
      ))}
    </nav>
  );

  const userControl = userInfo.isAuth ? (
    // {userInfo.type === 0 ? <LimitUser /> : null}
    <div className="flex-row"><UserMenu /></div>
  ) : (
    <a className="close-app" href="https://cryptohub.exchange/" target="_self" aria-label="Close Application" rel="noopener noreferrer">
      <i className="ri-close-line"></i>
    </a>
  );

  return (
    <header className={!userInfo.isAuth ? "no-auth" : ""}>
      {userInfo.isAuth && <BurgerMenu className="only-mobile" checkActive={(a, e) => checkActive(a, e)} location={location} />}
      <NavLink className="only-desktop" to="/" end >
        <img src={logo} alt="Company logo" />
      </NavLink>

      {userInfo.isAuth && navLinks}
      {userControl}
    </header>
  );
};

export default Headers;
